import { useEffect, useState } from "react";
import moment from "moment";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import MainHeading from "../../../components/comman/MainHeading";
import CommonTable from "../../../components/comman/CommonTable";
import ApproveRejectModal from "../../../components/comman/ApproveRejectModal";

export default function TeamWfh() {
  const [confirmModal, setConfirmModal] = useState(false);
  const [actionType, setActionType] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 1,
    tableLoader: false,
    wfhList: []
  });

  const getTeamWfhRequests = async () => {
    try {
      setPageStates((prev) => ({ ...prev, tableLoader: true }));
      const query = `pageNumber=${pageStates.currentPage}&pageSize=${pageStates.pageSize}&teamUserId=true`;
      const res = await callApi(`${apiUrl.get_wfh}${query}`);
      const rawRows = res?.data?.wfhRequest || res?.data?.rows || [];
      const formattedData = rawRows.map((item) => ({
        ...item,
        empName: item?.user?.name || "--",
        startDateFormatted: item?.startDate ? moment(item.startDate).format("DD/MM/YYYY") : "--",
        endDateFormatted: item?.endDate ? moment(item.endDate).format("DD/MM/YYYY") : "--",
        wfhStatus: item?.status
      }));

      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
        wfhList: formattedData,
        count: res?.data?.count || formattedData.length,
        totalPages: res?.data?.totalPages || 1
      }));
    } catch (err) {
      setPageStates((prev) => ({ ...prev, tableLoader: false }));
      toast.error(err?.message || "Error fetching team WFH requests");
    }
  };

  useEffect(() => {
    getTeamWfhRequests();
  }, [pageStates.currentPage, pageStates.pageSize]);

  const handleStatusChange = async (reason) => {
    if (!selectedRow) return;
    try {
      setIsSubmitting(true);
      const status = actionType === "approve" ? 1 : 2;
      const payload = {
        wfhRequestId: selectedRow.id,
        status,
        ...(reason && { reason })
      };
      const res = await callApi(apiUrl.update_wfh_status, { method: "POST", data: payload });
      setIsSubmitting(false);
      if (res?.statuscode === 200 || res?.status === true) {
        toast.success(res?.message || `WFH ${actionType === "approve" ? "Approved" : "Rejected"}`);
        setConfirmModal(false);
        setSelectedRow(null);
        getTeamWfhRequests();
      } else {
        toast.error(res?.message || "Failed to update status");
      }
    } catch (err) {
      setIsSubmitting(false);
      toast.error(err?.message || "Error updating status");
    }
  };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "empName", label: "Employee Name" },
    { value: "startDateFormatted", label: "From" },
    { value: "endDateFormatted", label: "To" },
    { value: "reason", label: "Reason" },
    { value: "wfhStatus", label: "Status" }
  ];

  const ActionData = [
    {
      label: "Approve",
      className: "btn btn-sm btn-success me-1",
      title: "Approve",
      isShow: 0,
      isSiteEditable: false,
      isVisible: false,
      clickHandler: (row) => {
        setSelectedRow(row);
        setActionType("approve");
        setConfirmModal(true);
      }
    },
    {
      label: "Reject",
      className: "btn btn-sm btn-danger",
      title: "Reject",
      isShow: 0,
      isSiteEditable: false,
      isVisible: false,
      clickHandler: (row) => {
        setSelectedRow(row);
        setActionType("reject");
        setConfirmModal(true);
      }
    }
  ];

  return (
    <div className="content p-4">
      <MainHeading title="Team Work From Home (WFH) Requests" />

      <div className="card mt-4">
        <div className="card-body">
          <CommonTable
            TableHeading={TableHeading}
            TableData={pageStates.wfhList}
            ActionData={ActionData}
            currentPage={pageStates.currentPage}
            PageChangeHandler={(page) => setPageStates((prev) => ({ ...prev, currentPage: page }))}
            isLoading={pageStates.tableLoader}
            totalPages={pageStates.totalPages}
            count={pageStates.count}
            handleChangePageSize={(size) => setPageStates((prev) => ({ ...prev, pageSize: size }))}
            pageSize={pageStates.pageSize}
          />
        </div>
      </div>

      <ApproveRejectModal
        modal={confirmModal}
        toggle={() => {
          setConfirmModal(!confirmModal);
          if (confirmModal) setSelectedRow(null);
        }}
        submitHandler={(reason) => handleStatusChange(reason)}
        isLoading={isSubmitting}
        actionType={actionType}
      />
    </div>
  );
}
